module.exports = __webpack_public_path__ + "static/media/29ADMSPC7.1d244d66.jpg";